export const READONLY_WHITE_LIST = [
  "/sendings/filtered?",
  "/subscriptions?",
  "/subscriptions/count",
  "/errors/log",
  "/stats/real-time",
  "/token",
];
